<template>
  <v-menu bottom left :close-on-content-click="false">
    <template v-slot:activator="{ on, attrs }">
      <v-badge
        overlap
        :content="activeFiltersAmount"
        :value="activeFiltersAmount !== 0"
      >
        <v-btn dark icon color="primary" v-bind="attrs" v-on="on">
          <v-icon>mdi-filter-menu-outline</v-icon>
        </v-btn>
      </v-badge>
    </template>
    <v-list>
      <v-list-item>
        <v-switch label="Multimatch" v-model="internalMultimatch" />
      </v-list-item>
      <v-list-item v-if="!hideShowPriceDetailsToggle">
        <v-switch label="Show price details" v-model="showPrice" />
      </v-list-item>
      <v-list-item>
        <v-switch label="Exclude Ignored" v-model="excludeIgnore" />
      </v-list-item>
      <v-list-item v-if="!hideReviewedToggle">
        <v-switch label="Reviewed" v-model="reviewed" />
      </v-list-item>
      <v-list-item>
        <v-switch label="Customer verified" v-model="customerVerified" />
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'FileFilters',
  props: {
    hideShowPriceDetailsToggle: {
      type: Boolean,
      default: false
    },
    hideReviewedToggle: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      internalMultimatch: false,
      excludeIgnore: false,
      showPrice: true,
      reviewed: false,
      customerVerified: false
    };
  },
  watch: {
    internalMultimatch(newValue) {
      this.$emit('onChange', { filter: 'multimatch', value: newValue });
    },
    excludeIgnore(newValue) {
      this.$emit('onChange', { filter: 'excludeIgnore', value: newValue });
    },
    showPrice(newValue) {
      this.$emit('onChange', { filter: 'showPrice', value: newValue });
    },
    reviewed(newValue) {
      this.$emit('onChange', { filter: 'reviewed', value: newValue });
    },
    customerVerified(newValue) {
      this.$emit('onChange', { filter: 'customerVerified', value: newValue });
    }
  },
  computed: {
    activeFiltersAmount() {
      let amount = 0;

      if (this.internalMultimatch) {
        amount++;
      }
      if (this.excludeIgnore) {
        amount++;
      }
      if (this.showPrice && !this.hideShowPriceDetailsToggle) {
        amount++;
      }
      if (this.reviewed && !this.hideReviewedToggle) {
        amount++;
      }
      if (this.customerVerified) {
        amount++;
      }

      return amount;
    }
  },
  methods: {
    resetMultimatch() {
      this.internalMultimatch = false;
    }
  }
};
</script>
